// extracted by mini-css-extract-plugin
export default {"document":"Document_document__Yfzy1"};